import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { windowOpenNoOpener } from '../../../base/browser/dom.js';
import { Schemas } from '../../../base/common/network.js';
import { CodeEditorServiceImpl } from '../../browser/services/codeEditorServiceImpl.js';
export var StandaloneCodeEditorServiceImpl = /*#__PURE__*/function (_CodeEditorServiceImp) {
  _inherits(StandaloneCodeEditorServiceImpl, _CodeEditorServiceImp);

  var _super = _createSuper(StandaloneCodeEditorServiceImpl);

  function StandaloneCodeEditorServiceImpl() {
    _classCallCheck(this, StandaloneCodeEditorServiceImpl);

    return _super.apply(this, arguments);
  }

  _createClass(StandaloneCodeEditorServiceImpl, [{
    key: "getActiveCodeEditor",
    value: function getActiveCodeEditor() {
      return null; // not supported in the standalone case
    }
  }, {
    key: "openCodeEditor",
    value: function openCodeEditor(input, source, sideBySide) {
      if (!source) {
        return Promise.resolve(null);
      }

      return Promise.resolve(this.doOpenEditor(source, input));
    }
  }, {
    key: "doOpenEditor",
    value: function doOpenEditor(editor, input) {
      var model = this.findModel(editor, input.resource);

      if (!model) {
        if (input.resource) {
          var schema = input.resource.scheme;

          if (schema === Schemas.http || schema === Schemas.https) {
            // This is a fully qualified http or https URL
            windowOpenNoOpener(input.resource.toString());
            return editor;
          }
        }

        return null;
      }

      var selection = input.options ? input.options.selection : null;

      if (selection) {
        if (typeof selection.endLineNumber === 'number' && typeof selection.endColumn === 'number') {
          editor.setSelection(selection);
          editor.revealRangeInCenter(selection, 1
          /* Immediate */
          );
        } else {
          var pos = {
            lineNumber: selection.startLineNumber,
            column: selection.startColumn
          };
          editor.setPosition(pos);
          editor.revealPositionInCenter(pos, 1
          /* Immediate */
          );
        }
      }

      return editor;
    }
  }, {
    key: "findModel",
    value: function findModel(editor, resource) {
      var model = editor.getModel();

      if (model && model.uri.toString() !== resource.toString()) {
        return null;
      }

      return model;
    }
  }]);

  return StandaloneCodeEditorServiceImpl;
}(CodeEditorServiceImpl);